module.exports = __webpack_public_path__ + "static/media/icon_192.5da2018b.svg";